import { c as _c } from "react/compiler-runtime";
export default function UserPageRepModifyModalHeader(t0) {
  const $ = _c(10);
  const {
    handleOrWallet,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><span className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-11 tw-w-11 tw-bg-iron-800 tw-border tw-border-solid tw-border-iron-700"><svg className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-text-iron-50 group-hover:tw-scale-105 tw-transition tw-duration-300 tw-ease-out" clipRule="evenodd" fillRule="evenodd" height="512" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_4803084"><path fill="currentColor" d="m15.628 2c-3.864 0-7 3.137-7 7s3.136 7 7 7c3.863 0 7-3.137 7-7s-3.137-7-7-7zm0 2c2.759 0 5 2.24 5 5s-2.241 5-5 5c-2.76 0-5-2.24-5-5s2.24-5 5-5z" /><path fill="currentColor" d="m3.628 28h12.372c.552 0 1 .448 1 1s-.448 1-1 1h-13.372c-.553 0-1-.448-1-1 0 0 0-.825 0-2 0-4.971 4.029-9 9-9h5.377c.552 0 1 .448 1 1s-.448 1-1 1h-5.377c-3.866 0-7 3.134-7 7z" /><path fill="currentColor" d="m21.917 20.108 1.725-3.332c.172-.332.515-.54.888-.54.374 0 .717.208.888.54l1.726 3.332 3.702.612c.369.061.673.322.788.677.116.356.024.746-.239 1.012l-2.636 2.671.563 3.71c.056.369-.099.739-.401.959-.302.219-.702.252-1.036.085l-3.355-1.682-3.354 1.682c-.334.167-.734.134-1.036-.085-.302-.22-.457-.59-.401-.959l.562-3.71-2.635-2.671c-.263-.266-.355-.656-.24-1.012.116-.355.42-.616.789-.677zm2.613-.698-1.068 2.063c-.145.28-.414.475-.725.527l-2.291.378 1.631 1.654c.222.224.324.54.277.852l-.348 2.296 2.076-1.04c.282-.142.615-.142.897 0l2.076 1.04-.348-2.296c-.047-.312.055-.628.277-.852l1.631-1.654-2.291-.378c-.312-.052-.58-.247-.725-.527z" /></svg></span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== handleOrWallet) {
    t2 = <div className="tw-max-w-xl sm:tw-flex tw-items-center sm:tw-space-x-4">{t1}<p className="tw-mt-3 sm:tw-mt-0 tw-pr-8 tw-text-wrap tw-truncate md:tw-max-w-sm tw-text-lg tw-text-iron-50 tw-font-semibold tw-mb-0">Add Rep to {handleOrWallet}</p></div>;
    $[1] = handleOrWallet;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-sr-only tw-text-sm">Close</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-h-6 tw-w-6" aria-hidden="true" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClose) {
    t5 = <div className="tw-absolute tw-right-4 tw-top-4 sm:tw-top-6 tw-flex tw-justify-between tw-items-center"><button onClick={onClose} type="button" className="tw-p-2.5 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-iron-950 tw-border-0 tw-text-iron-400 hover:tw-text-iron-50 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out">{t3}{t4}</button></div>;
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div className="tw-flex tw-justify-between">{t2}{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}